import _ from "lodash";
import {
    ADD_CUSTOMER_SEGMENT,
    ADD_PRESENTATION,
    DELETE_CUSTOMER_SEGMENT,
    EDIT_CUSTOMER_SEGMENT,
    EDIT_PRESENTATION,
    FETCH_PRESENTATIONS
} from "../actions/types";

// const INITIAL_STATE = {
//     presentation: {},
// }

const presentationReducer = (state = {}, action) => {
    switch (action.type) {

        case ADD_PRESENTATION:
            return { ...state, [action.payload.presentation.id]: action.payload.presentation }
        case FETCH_PRESENTATIONS:
            return { ...state, ..._.mapKeys(action.payload.presentation, 'id') }
        case EDIT_PRESENTATION:
            return { ...state, [action.payload.presentation.id]: action.payload.presentation }
        case ADD_CUSTOMER_SEGMENT:
            return { ...state, [action.payload.presentation.id]: action.payload.presentation }
        case EDIT_CUSTOMER_SEGMENT:
            return { ...state, [action.payload.presentation.id]: action.payload.presentation }
        case DELETE_CUSTOMER_SEGMENT:
            return { ...state, [action.payload.presentation.id]: action.payload.presentation }

        default:
            return state;
    }
};

export default presentationReducer